import React, { useEffect, useState } from 'react';
import './Login.css';
import { Disclosure } from './Disclosure';
import { useAuth } from '../../contexts/AuthContext';
import { ExternalLink } from './ExternalLink';
import i18n from '../../i18n';
import {
    IDENTITO_BASE_URL_LIVE,
    IDENTITO_BASE_URL_QA,
    IDENTITO_CLIENT_ID_LIVE,
    IDENTITO_CLIENT_ID_QA,
    SOPORTO_HOSTS_LIVE,
    SOPORTO_HOSTS_QA
} from './constants';

export const Login = ({ showRtbfForm, lang }) => {
    const { state, setState } = useAuth();
    const [identitoState, setIdentitoState] = useState(null);
    const getCopy = (i18nKey) => i18n.getCopy(lang, i18nKey);

    useEffect(() => {
        const receiveMessage = (event) => {
            if (!identitoState) {
                return;
            }

            if (event.origin !== identitoState.baseUrl) {
                return;
            }
            if (event.data.messageType === 'authCompleted' && event.data.resultCode === 1 && event.data.coreUserId) {
                setState({
                    isLoggedIn: true,
                    cuid: event.data.coreUserId,
                    sessionKey: event.data.sessionKey
                });
            }
        };
        window.addEventListener('message', receiveMessage, false);
        return () => window.removeEventListener('message', receiveMessage);
    }, [identitoState]);

    useEffect(() => {
        if (SOPORTO_HOSTS_QA.includes(window.location.host)) {
            setIdentitoState({ baseUrl: IDENTITO_BASE_URL_QA, clientId: IDENTITO_CLIENT_ID_QA });
        }

        if (SOPORTO_HOSTS_LIVE.includes(window.location.host)) {
            setIdentitoState({ baseUrl: IDENTITO_BASE_URL_LIVE, clientId: IDENTITO_CLIENT_ID_LIVE });
        }
    }, []);

    useEffect(() => {
        if (state.isLoggedIn) {
            showRtbfForm();
        }
    }, [state.isLoggedIn]);

    return (
        <div className="LoginContainer">
            <h2
                dangerouslySetInnerHTML={{
                    __html: getCopy('support.form.login.title')
                }}
                className="Title"
            />
            <iframe
                title="AaaS"
                src={`${identitoState ? identitoState.baseUrl : ''}/player-auth?client-id=${
                    identitoState ? identitoState.clientId : ''
                }&client-origin=${encodeURIComponent(window.location.origin)}&lang=${new Intl.Locale(navigator.language)}`}
                style={{ width: '100%', minHeight: '390px', border: 'none' }}
            />
            <p>
                <span
                    dangerouslySetInnerHTML={{
                        __html: getCopy('support.form.login.accept_tos_pp')
                            .replace(
                                '{0}',
                                '<a\n' +
                                    'class="Link"\n' +
                                    'href="https://www.king.com/termsAndConditions"\n' +
                                    'target="_blank"\n' +
                                    'rel="noopener noreferrer">'
                            )
                            .replace('{1}', '</a>')
                            .replace(
                                '{2}',
                                '<a\n' +
                                    'class="Link"\n' +
                                    'href="https://www.king.com/privacyPolicy"\n' +
                                    'target="_blank"\n' +
                                    'rel="noopener noreferrer">'
                            )
                            .replace('{3}', '</a>')
                    }}
                />
                <span className="ExternalLinkContainer">
                    <ExternalLink />
                </span>
            </p>

            <Disclosure
                buttonText={getCopy('support.form.login.faq.king_account.title')}
                content={
                    <div
                        dangerouslySetInnerHTML={{
                            __html: getCopy('support.form.login.faq.king_account.content')
                        }}
                    />
                }
            />
            <Disclosure
                buttonText={getCopy('support.form.login.faq.king_account_create.title')}
                content={
                    <div
                        dangerouslySetInnerHTML={{
                            __html: getCopy('support.form.login.faq.king_account_create.content')
                        }}
                    />
                }
            />
            <Disclosure
                content={
                    <div>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: getCopy('support.form.login.faq.king_account.password.content')
                                    .replace(
                                        '{0}',
                                        '<a\n' +
                                            'class="Link"\n' +
                                            'href="https://community.king.com/en/kb/articles/247-how-do-i-change-my-king-account-password-or-email-address"\n' +
                                            'target="_blank"\n' +
                                            'rel="noopener noreferrer"\n>'
                                    )
                                    .replace('{1}', '</a>')
                            }}
                        />
                        <span className="ExternalLinkContainer">
                            <ExternalLink />
                        </span>
                    </div>
                }
                buttonText={getCopy('support.form.login.faq.king_account.password.title')}
            />
            <Disclosure
                buttonText={getCopy('support.form.login.faq.no_king_account.title')}
                content={
                    <div
                        dangerouslySetInnerHTML={{
                            __html: getCopy('support.form.login.faq.no_king_account.content')
                                .replace('{0}', '<a class="Link" rel="noopener noreferrer" href="/">')
                                .replace('{1}', '</a>')
                        }}
                    />
                }
            />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/Login/Login.js